export default __webpack_public_path__ + "static/media/intercom-icon.1ec6795b.svg";